<ng-container *ngIf="options">
  <ion-item
    *ngFor="let option of options"
    id="{{ id }}-{{ option.value }}"
    class="ion-margin-bottom"
    [class.no-padding-end]="!!option.description"
    [lines]="'none'"
    (click)="mapChecked(option)"
  >
    <ion-icon
      slot="start"
      class="checkmark-icon"
      [src]="currentSelected.includes(option.value) ? 'assets/icon/checkbox-on.svg' : 'assets/icon/checkbox-off.svg'"
    ></ion-icon>
    <div class="checkbox-label-container">
      <ion-text class="main-text ion-text-wrap">{{ option.text }}</ion-text>
      <ion-text class="sub-text ion-text-wrap">{{ option.subtext }}</ion-text>
    </div>
    <div slot="end" class="info-btn-container ion-no-margin">
      @if (option.description){
      <ion-button [id]="'open_info-' + option.value" color="secondary" expand="block" mode="md" fill="clear" (click)="$event.stopPropagation()">
        <fa-icon slot="end" size="xl" [icon]="faInfoCircle"></fa-icon>
      </ion-button>

      <ion-modal #modal [trigger]="'open_info-' + option.value" class="description-card" [breakpoints]="[0, 1]" [initialBreakpoint]="1">
        <ng-template>
          <ion-header>
            <ion-toolbar>
              <ion-title></ion-title>
              <ion-buttons slot="end">
                <ion-button color="primary" mode="md" (click)="modal.dismiss()">Close</ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            <ion-text>
              <h1>{{ option.text }}</h1>
            </ion-text>
            <p [innerHtml]="option.description"></p>
          </ion-content>
        </ng-template>
      </ion-modal>
      }
    </div>
  </ion-item>
</ng-container>
